module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-08.1a0d213e.jpg";